export const generateBoxTypeModel = () => ({
  name: '',
  boxType: '',
  innerHeight: null,
  innerLength: null,
  innerWidth: null,
  outerHeight: null,
  outerLength: null,
  outerWidth: null,
  shippingBox: false,
  sizeUnits: '',
});
